<template>
    <div
		:id="containerId"
		:class="containerClass"
	>
        <div class="animated-checkbox checkbox-xs-2">
            <label>
                <input 
                    type="checkbox" 
                    :name="name"
                    :value="value"
                    :required="required"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :checked="checked"
                >
                <span class="label-text">{{ label }}</span>
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            placeholder: String,
            label: String,
            name: String,
            value: String | Number,
            checked: Boolean,
            required: Boolean,
            disabled: { type: Boolean, default: false },
            containerId: String,
			containerClass: { type: String, default: 'col-12 col-xl-4 col-md-6' },
        }
    }
</script>